import script from "./SettingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingCard.vue?vue&type=script&setup=true&lang=js"

import "./SettingCard.vue?vue&type=style&index=0&id=0eb055af&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb055af"]])

export default __exports__